import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vue:setup", () => {
    if (import.meta.client) {
      const style = "background: linear-gradient(30deg, #770971, #fe4317 70%); color: #ffffff; font-family: sans-serif; font-weight: bold; text-align: center; padding: 2rem 2rem;";
      console.log("%cBUILD BY FLYING KIWI", style);
    }
    return {
      provide: {
        flyingkiwi: { ...nuxtApp.$config.public.flyingkiwi }
      }
    };
  });
});
